
<section class="justify-center mx-6 sm:mx-16 h-screen">
    <!-- Top Search & Filter Bar -->
    <div class="flex flex-col sm:flex-row gap-2">
      <div class="flex flex-1">
        <input autofocus (keyup.enter)="searchCollection(collectionName, searchQuery, searchLimit)" type="text" name="query" id="query" [(ngModel)]="searchQuery" class="w-full rounded-l-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Búsqueda semántica en embeddings...">
        <input type="number" name="limit" id="limit" [(ngModel)]="searchLimit" class="w-16 bg-white px-2 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Límite">
        <a (click)="searchCollection(collectionName,searchQuery,searchLimit)" class="rounded-r-md bg-orange-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 hover:cursor-pointer flex items-center justify-center">
          <svg class="size-4 mr-1 inline" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          Buscar
        </a>
      </div>
      
      <!-- Toggle Filter Button -->
      <button (click)="toggleFilterPanel()" type="button" class="inline-flex items-center justify-center gap-x-1.5 rounded-md px-3 py-1.5 text-sm font-semibold shadow-sm ring-1 ring-inset transition-colors cursor-pointer" [ngClass]="isFilterActive() ? 'bg-orange-50 text-orange-700 ring-orange-300 hover:bg-orange-100' : 'bg-white text-gray-700 ring-gray-300 hover:bg-gray-50'">
        <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.539.092.917.56.917 1.106v1.442a4.5 4.5 0 0 1-1.318 3.182l-5.368 5.368a4.5 4.5 0 0 0-1.314 3.182V20.25a.75.75 0 0 1-1.12.65l-3-1.714a.75.75 0 0 1-.38-.65v-3.238a4.5 4.5 0 0 0-1.314-3.182L2.318 9.408A4.5 4.5 0 0 1 1 6.226V4.784c0-.546.378-1.014.917-1.106A48.583 48.583 0 0 1 12 3Z" />
        </svg>
        <span>Filtro de metadatos</span>
        <span *ngIf="getActiveFilterCount() > 0" class="ml-1 rounded-full bg-orange-600 px-1.5 py-0.5 text-xs font-bold text-white leading-none">
          {{ getActiveFilterCount() }}
        </span>
        <svg class="size-4 ml-1 transition-transform duration-200" [ngClass]="{'rotate-180': isFilterPanelOpen}" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </button>

      <!-- Clear filters button if active -->
      <button *ngIf="isFilterActive()" (click)="resetFilters()" type="button" class="inline-flex items-center rounded-md bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-200 hover:text-gray-900 transition-colors cursor-pointer" title="Restablecer todos los filtros">
        <svg class="size-4 mr-1" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
        Limpiar
      </button>
    </div>

    <!-- Collapsible Filter Panel -->
    <div *ngIf="isFilterPanelOpen" class="mt-3 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-200">
      <div class="flex items-center justify-between pb-3 mb-3 border-b border-gray-100">
        <h3 class="text-sm font-bold text-gray-900 flex items-center gap-1.5">
          <svg class="size-4 text-orange-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
          </svg>
          Filtros de metadatos y contenido
        </h3>
        <button *ngIf="isFilterActive()" (click)="resetFilters()" type="button" class="text-xs text-orange-600 hover:text-orange-800 font-semibold cursor-pointer">
          Restablecer todos los filtros
        </button>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- 1. Texto contenido -->
        <div class="space-y-2 md:col-span-1">
          <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Texto contenido</label>
          <div class="relative">
            <input type="text" [(ngModel)]="filterKeywords" (keyup.enter)="applyFilters()" placeholder="Buscar palabras clave (Enter para aplicar)..." class="block w-full rounded-md bg-white px-3 py-1.5 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600" />
            <button *ngIf="filterKeywords" (click)="filterKeywords = ''" class="absolute right-2.5 top-2 text-gray-400 hover:text-gray-600">
              <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
            </button>
          </div>
          <div class="flex flex-wrap items-center gap-3 pt-1 text-xs text-gray-600">
            <span class="font-medium text-gray-500">Buscar en:</span>
            <label class="inline-flex items-center gap-1 cursor-pointer select-none">
              <input type="checkbox" [(ngModel)]="filterTextFields['document']" class="rounded border-gray-300 text-orange-600 focus:ring-orange-600">
              <span>document</span>
            </label>
            <label class="inline-flex items-center gap-1 cursor-pointer select-none">
              <input type="checkbox" [(ngModel)]="filterTextFields['title']" class="rounded border-gray-300 text-orange-600 focus:ring-orange-600">
              <span>title</span>
            </label>
            <label class="inline-flex items-center gap-1 cursor-pointer select-none">
              <input type="checkbox" [(ngModel)]="filterTextFields['summary']" class="rounded border-gray-300 text-orange-600 focus:ring-orange-600">
              <span>summary</span>
            </label>
            <label class="inline-flex items-center gap-1 cursor-pointer select-none">
              <input type="checkbox" [(ngModel)]="filterTextFields['tags']" class="rounded border-gray-300 text-orange-600 focus:ring-orange-600">
              <span>tags</span>
            </label>
          </div>
        </div>

        <!-- 2. Rango temporal (timestamp) -->
        <div class="space-y-2 md:col-span-1">
          <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Rango temporal (timestamp)</label>
          <div class="grid grid-cols-2 gap-2">
            <div>
              <span class="text-xs text-gray-500 block mb-0.5">Desde:</span>
              <input type="date" [(ngModel)]="filterStartDate" class="block w-full rounded-md bg-white px-2.5 py-1.5 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600" />
            </div>
            <div>
              <span class="text-xs text-gray-500 block mb-0.5">Hasta:</span>
              <input type="date" [(ngModel)]="filterEndDate" class="block w-full rounded-md bg-white px-2.5 py-1.5 text-sm text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600" />
            </div>
          </div>
        </div>

        <!-- 3. Categoría (category) & Sensibilidad (sensitivity) -->
        <div class="space-y-3 md:col-span-1">
          <!-- Categoría -->
          <div class="space-y-1.5">
            <div class="flex items-center justify-between">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Categoría (category)</label>
              <button *ngIf="selectedCategories.length > 0" (click)="selectedCategories = []" class="text-[11px] text-gray-400 hover:text-gray-600 cursor-pointer">deseleccionar</button>
            </div>
            <div class="flex flex-wrap gap-1.5">
              <button *ngFor="let opt of categoryOptions" (click)="toggleFilterItem(selectedCategories, opt)" type="button" class="rounded-md px-2.5 py-1 text-xs font-medium transition-colors cursor-pointer" [ngClass]="isFilterItemSelected(selectedCategories, opt) ? 'bg-orange-600 text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
                {{ opt }}
              </button>
            </div>
          </div>

          <!-- Sensibilidad -->
          <div class="space-y-1.5">
            <div class="flex items-center justify-between">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Sensibilidad (sensitivity)</label>
              <button *ngIf="selectedSensitivity.length > 0" (click)="selectedSensitivity = []" class="text-[11px] text-gray-400 hover:text-gray-600 cursor-pointer">deseleccionar</button>
            </div>
            <div class="flex flex-wrap gap-1.5">
              <button *ngFor="let opt of sensitivityOptions" (click)="toggleFilterItem(selectedSensitivity, opt)" type="button" class="rounded-md px-3 py-1 text-xs font-medium transition-colors cursor-pointer" [ngClass]="isFilterItemSelected(selectedSensitivity, opt) ? 'bg-orange-600 text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
                {{ opt }}
              </button>
            </div>
          </div>
        </div>

        <!-- 4. Relevancia Cuidador (relevance_caregiver) & Sentimiento (sentiment) -->
        <div class="space-y-3 md:col-span-1">
          <!-- Relevancia cuidador -->
          <div class="space-y-1.5">
            <div class="flex items-center justify-between">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Relevancia cuidador</label>
              <button *ngIf="selectedRelevanceCaregiver.length > 0" (click)="selectedRelevanceCaregiver = []" class="text-[11px] text-gray-400 hover:text-gray-600 cursor-pointer">deseleccionar</button>
            </div>
            <div class="flex flex-wrap gap-1.5">
              <button *ngFor="let opt of relevanceCaregiverOptions" (click)="toggleFilterItem(selectedRelevanceCaregiver, opt)" type="button" class="rounded-md px-2.5 py-1 text-xs font-medium transition-colors cursor-pointer" [ngClass]="isFilterItemSelected(selectedRelevanceCaregiver, opt) ? 'bg-orange-600 text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
                {{ opt }}
              </button>
            </div>
          </div>

          <!-- Sentimiento -->
          <div class="space-y-1.5">
            <div class="flex items-center justify-between">
              <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Sentimiento (sentiment)</label>
              <button *ngIf="selectedSentiments.length > 0" (click)="selectedSentiments = []" class="text-[11px] text-gray-400 hover:text-gray-600 cursor-pointer">deseleccionar</button>
            </div>
            <div class="flex flex-wrap gap-1.5">
              <button *ngFor="let opt of sentimentOptions" (click)="toggleFilterItem(selectedSentiments, opt)" type="button" class="rounded-md px-2.5 py-1 text-xs font-medium transition-colors cursor-pointer" [ngClass]="isFilterItemSelected(selectedSentiments, opt) ? 'bg-orange-600 text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
                {{ opt }}
              </button>
            </div>
          </div>
        </div>

        <!-- 5. Temas (topics) -->
        <div class="space-y-1.5 md:col-span-2">
          <div class="flex items-center justify-between">
            <label class="block text-xs font-semibold uppercase tracking-wider text-gray-700">Temas (topics)</label>
            <button *ngIf="selectedTopics.length > 0" (click)="selectedTopics = []" class="text-[11px] text-gray-400 hover:text-gray-600 cursor-pointer">deseleccionar</button>
          </div>
          <div class="flex flex-wrap gap-1.5">
            <button *ngFor="let opt of topicOptions" (click)="toggleFilterItem(selectedTopics, opt)" type="button" class="rounded-md px-2.5 py-1 text-xs font-medium transition-colors cursor-pointer" [ngClass]="isFilterItemSelected(selectedTopics, opt) ? 'bg-orange-600 text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
              {{ opt }}
            </button>
          </div>
        </div>
      </div>

      <!-- Barra de acciones: Restablecer, Cerrar y Aplicar filtros -->
      <div class="mt-4 pt-3 border-t border-gray-100 flex flex-wrap items-center justify-between gap-2">
        <button (click)="resetFilters()" type="button" class="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-800 font-medium cursor-pointer py-1.5 px-2 rounded hover:bg-gray-100 transition-colors">
          <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
          Restablecer filtros
        </button>
        <div class="flex items-center gap-2">
          <button (click)="cancelFilters()" type="button" class="inline-flex items-center rounded-md bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 cursor-pointer transition-colors">
            Cerrar
          </button>
          <button (click)="applyFilters()" type="button" class="inline-flex items-center gap-1.5 rounded-md bg-orange-600 px-4 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-orange-500 cursor-pointer transition-colors">
            <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
            </svg>
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>

    <br/>
    <div class="fixed bottom-3 right-5 flex justify-end px-2 pt-0 pb-5 z-20">
        <button (click)="createModal()" type="button" class="rounded-full bg-orange-600 p-2 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600 cursor-pointer">
            <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
            </svg>
        </button>
    </div>

    <!-- Results Counter -->
    <div class="text-center italic pb-3 text-sm text-gray-600">
      <span *ngIf="isFilterActive()">
        Mostrando <strong class="text-orange-600 font-bold">{{ filteredDocuments.length }}</strong> de {{ collectionDocs }} documentos encontrados con filtros activos
      </span>
      <span *ngIf="!isFilterActive()">
        {{ collectionDocs }} documentos encontrados
      </span>
    </div>

    <!-- Empty state when no documents match filters -->
    <div *ngIf="filteredDocuments.length === 0 && collectionDocs > 0" class="my-8 text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
      <svg class="mx-auto size-10 text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <p class="text-sm font-semibold text-gray-900">No se encontraron documentos</p>
      <p class="text-xs text-gray-500 mt-1">Ningún documento coincide con los criterios de filtrado seleccionados.</p>
      <button (click)="resetFilters()" type="button" class="mt-3 inline-flex items-center rounded-md bg-orange-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-orange-500 cursor-pointer">
        Restablecer filtros
      </button>
    </div>

    <ul role="list" class="divide-y divide-gray-100">
      <div *ngFor="let document of filteredDocuments.slice().reverse()"> 
          <li class="flex items-center justify-between gap-x-6 py-3">
            <div class="min-w-0">
              <div class="flex items-start gap-x-3">
                <p (click)="openInfo(document)" class="cursor-pointer text-sm/6 font-semibold text-gray-900">[{{document.id}}] {{document.text}}</p>
                <!-- <p class="mt-0.5 whitespace-nowrap rounded-md bg-gray-50 px-1.5 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">In progress</p> -->
              </div>
              <!-- <div class="mt-1 flex items-center gap-x-2 text-xs/5 text-gray-500">
                <p class="whitespace-nowrap">Due on <time datetime="2023-05-05T00:00Z">May 5, 2023</time></p>
                <svg viewBox="0 0 2 2" class="size-0.5 fill-current">
                  <circle cx="1" cy="1" r="1" />
                </svg>
                <p class="truncate">Created by Leslie Alexander</p>
              </div> -->
            </div>
            <div class="flex flex-none items-center gap-x-4">
              <div class="relative flex-none">
                <button (click)="openDropdown(document) " type="button" class="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900" id="options-menu-1-button" aria-expanded="false" aria-haspopup="true">
                  <span class="sr-only">Open options</span>
                  <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                    <path d="M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                  </svg>
                </button>
        
                <!--
                  Dropdown menu, show/hide based on menu state.
        
                  Entering: "transition ease-out duration-100"
                    From: "transform opacity-0 scale-95"
                    To: "transform opacity-100 scale-100"
                  Leaving: "transition ease-in duration-75"
                    From: "transform opacity-100 scale-100"
                    To: "transform opacity-0 scale-95"
                -->
                <div *ngIf="document.dropdown" class="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="options-menu-1-button" tabindex="-1">
                  <!-- Active: "bg-gray-50 outline-none", Not Active: "" -->
                  <a (click)="openModal(document,'edit')" class="block px-3 py-1 text-sm/6 text-gray-900 hover:cursor-pointer hover:bg-green-200" role="menuitem" tabindex="-1" id="options-menu-1-item-0">Edit<span class="sr-only"></span></a>
                  <a (click)="openModal(document,'delete')" class="block px-3 py-1 text-sm/6 text-gray-900 hover:cursor-pointer hover:bg-red-200" role="menuitem" tabindex="-1" id="options-menu-1-item-2">Delete<span class="sr-only"></span></a>
                </div>
              </div>
            </div>
          </li>
            <div *ngIf="document.info" class="mb-2 bg-gray-50 border border-gray-200 rounded-xl shadow-md border-white/10">
              <dl class="divide-y divide-white/10">
                <div *ngFor="let item of document.metadata | keyvalue" class="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt class="pl-12 text-sm/6 font-medium text-black">
                    {{ item.key }}
                  </dt>
                  <dd class="mt-1 text-sm/6 text-gray-800 sm:col-span-2 sm:mt-0">
                    {{ item.value }}
                  </dd>
                </div>
              </dl>
            </div>          
        </div>
      </ul>
      
</section>


<!-- Delete modal -->
<section>
    <div *ngIf="delete_modal.visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                  <svg class="size-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{delete_modal.title}}</p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button (click)="deleteDocument(delete_modal.document)" type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Eliminar</button>
                <button (click)="delete_modal.visible = !delete_modal.visible" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>


<!-- Edit modal -->
<section>
    <div *ngIf="edit_modal.visible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <!--
          Background backdrop, show/hide based on modal state.
      
          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
      
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <!--
              Modal panel, show/hide based on modal state.
      
              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                To: "opacity-100 translate-y-0 sm:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 sm:scale-100"
                To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            -->
            <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="sm:flex sm:items-start">
                <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-orange-100 sm:mx-0 sm:size-10">
                  <svg class="size-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold text-gray-900" id="modal-title"></h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{edit_modal.title}}</p>
                  </div>
                </div>
              </div>
              <div class="relative my-4 max-h-[65vh] overflow-y-auto px-1">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
                  <!-- Contenido (Document text) -->
                  <div class="sm:col-span-2">
                    <label for="text" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Contenido<span class="text-red-500">*</span></label>
                    <textarea rows="3" aria-required="true" name="text" id="text" [(ngModel)]="edit_modal.document.text" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Texto del documento"></textarea>
                  </div>

                  <!-- Título -->
                  <div class="sm:col-span-2">
                    <label for="title" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Título</label>
                    <input type="text" name="title" id="title" [(ngModel)]="edit_modal.document.metadata.title" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Nuevo título">
                  </div>

                  <!-- Resumen (summary) -->
                  <div class="sm:col-span-2">
                    <label for="summary" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Resumen (summary)</label>
                    <textarea rows="2" name="summary" id="summary" [(ngModel)]="edit_modal.document.metadata.summary" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Resumen del documento"></textarea>
                  </div>

                  <!-- Temas -->
                  <div>
                    <label for="topics" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Temas</label>
                    <input type="text" name="topics" id="topics" [(ngModel)]="edit_modal.document.metadata.topics" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="ej. Emotional & Mental Health">
                  </div>

                  <!-- Tags -->
                  <div>
                    <label for="tags" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Tags / Etiquetas</label>
                    <input type="text" name="tags" id="tags" [(ngModel)]="edit_modal.document.metadata.tags" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="ej. boredom,mood">
                  </div>

                  <!-- Categoría -->
                  <div>
                    <label for="type" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Categoría</label>
                    <input type="text" name="type" id="type" [(ngModel)]="edit_modal.document.metadata.category" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="ej. PRESENT_EVENT">
                  </div>

                  <!-- Sentimiento -->
                  <div>
                    <label for="sentiment" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Sentimiento</label>
                    <input type="text" name="sentiment" id="sentiment" [(ngModel)]="edit_modal.document.metadata.sentiment" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="ej. NEUTRAL">
                  </div>

                  <!-- Fecha (datetime) -->
                  <div>
                    <label for="datetime" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Fecha (yyyy-mm-dd hh:mm)</label>
                    <input type="text" name="datetime" id="datetime" [(ngModel)]="edit_modal.document.metadata.datetime" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="2026-09-04 18:06">
                  </div>

                  <!-- Fecha relevante (relevant_datetime) -->
                  <div>
                    <label for="relevat_datetime" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Fecha relevante (yyyy-mm-dd hh:mm)</label>
                    <input type="text" name="relevat_datetime" id="relevat_datetime" [(ngModel)]="edit_modal.document.metadata.relevant_datetime" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="2026-09-04 15:06">
                  </div>

                  <!-- Relevancia IA -->
                  <div>
                    <label for="relevance_ai" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Relevancia IA</label>
                    <input type="number" name="relevance_ai" id="relevance_ai" [(ngModel)]="edit_modal.document.metadata.relevance_ai" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="0">
                  </div>

                  <!-- Relevancia cuidador -->
                  <div>
                    <label for="relevance_caregiver" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Relevancia cuidador</label>
                    <input type="text" name="relevance_caregiver" id="relevance_caregiver" [(ngModel)]="edit_modal.document.metadata.relevance_caregiver" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="ej. LOW">
                  </div>

                  <!-- Sesgo IA (bias_ai) -->
                  <div>
                    <label for="bias_ai" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Sesgo IA (bias_ai)</label>
                    <input type="text" inputmode="decimal" name="bias_ai" id="bias_ai" [(ngModel)]="edit_modal.document.metadata.bias_ai" (input)="onFloatInput('bias_ai')" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="0.6">
                  </div>

                  <!-- Confianza (confidence) -->
                  <div>
                    <label for="confidence" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Confianza (confidence)</label>
                    <input type="text" inputmode="decimal" name="confidence" id="confidence" [(ngModel)]="edit_modal.document.metadata.confidence" (input)="onFloatInput('confidence')" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="0.6">
                  </div>

                  <!-- Sensibilidad -->
                  <div>
                    <label for="sensitivity" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Sensibilidad</label>
                    <input type="number" name="sensitivity" id="sensitivity" [(ngModel)]="edit_modal.document.metadata.sensitivity" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="0">
                  </div>

                  <!-- Contador -->
                  <div>
                    <label for="counter" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Contador</label>
                    <input type="number" name="counter" id="counter" [(ngModel)]="edit_modal.document.metadata.counter" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="0">
                  </div>

                  <!-- ID de sesión -->
                  <div class="sm:col-span-2">
                    <label for="session_uuid" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">ID de sesión</label>
                    <input type="text" name="session_uuid" id="session_uuid" [(ngModel)]="edit_modal.document.metadata.session_uuid" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="UUID de sesión">
                  </div>

                  <!-- Timestamp -->
                  <div class="sm:col-span-2">
                    <label for="timestamp" class="relative top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900">Timestamp (ms epoch)</label>
                    <input type="number" name="timestamp" id="timestamp" [(ngModel)]="edit_modal.document.metadata.timestamp" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="1788545218935">
                  </div>
                </div>
              </div>
              
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button [disabled]="!edit_modal.document.text" (click)="editDocument(edit_modal.document)" type="button" class="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto" [class]="!edit_modal.document.text?'cursor-not-allowed':''">Guardar</button>
                <button (click)="closeModal()" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
</section>
